import { render, staticRenderFns } from "./index - 副本.vue?vue&type=template&id=b7327f52&scoped=true&"
import script from "./index - 副本.vue?vue&type=script&lang=js&"
export * from "./index - 副本.vue?vue&type=script&lang=js&"
import style0 from "./index - 副本.vue?vue&type=style&index=0&id=b7327f52&prod&scoped=true&langs=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7327f52",
  null
  
)

export default component.exports